var _defs, _path, _polygon, _circle, _circle2, _polygon2, _path2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMadmocoLogoBlack360X80(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.59,62.26c0,9.72,7.88,17.59,17.59,17.59h17.59v-35.19h-17.59c-9.72,0-17.59,7.88-17.59,17.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "277.59 .15 277.59 35.34 312.78 35.34 312.78 .15 295.18 17.74 277.59 .15"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 338.99,
    cy: 17.74,
    r: 17.59,
    transform: "translate(1.54 54.53) rotate(-9.22)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 338.99,
    cy: 62.26,
    r: 17.59,
    transform: "translate(151.75 351.62) rotate(-67.5)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.41 .15 3.41 79.85 83.11 79.85 83.11 .15 43.26 40 3.41 .15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.78.15h-39.85v79.7h39.85c22.01,0,39.85-17.84,39.85-39.85S247.79.15,225.78.15Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.67 79.85 134.52 79.85 174.37 79.85 134.52 .15 94.67 79.85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadmocoLogoBlack360X80);
export default __webpack_public_path__ + "static/media/madmoco_logo_black_360X80.71fc85bfdd6c9abd5ad4c7f47570cda7.svg";
export { ForwardRef as ReactComponent };